import { useEffect } from 'react'
import { Article } from '@app-core/eventTracking/article/Article'
import { FollowUIEvents, NavigationEvents } from '@libs/customEvents'
import {
  FollowActionType,
  trackArticleAuthorInfoEnterUserProfileEvent,
  trackArticleAuthorInfoFollowEvent,
} from '@libs/eventTracking/article'
import { TrackingSection } from '@features/post/contexts/TrackingSectionContext'

type TrackingSectionInfo = { section: TrackingSection }

export function useTrackArticleAuthorInfoEvent(article: Article) {
  useEffect(() => {
    const handler = ({
      detail: { actionType, section },
    }: CustomEventInit<{ actionType: FollowActionType } & TrackingSectionInfo>) => {
      if (section !== TrackingSection.ARTICLE_AUTHOR_INFO) return
      trackArticleAuthorInfoFollowEvent(article, actionType)
    }
    window.addEventListener(FollowUIEvents.CLICK_FOLLOW, handler)
    return () => {
      window.removeEventListener(FollowUIEvents.CLICK_FOLLOW, handler)
    }
  }, [])
  useEffect(() => {
    const handler = ({ detail: { section } }: CustomEventInit<TrackingSectionInfo>) => {
      if (section !== TrackingSection.ARTICLE_AUTHOR_INFO) return
      trackArticleAuthorInfoEnterUserProfileEvent(article)
    }
    window.addEventListener(NavigationEvents.ENTER_USER_PROFILE, handler)
    return () => {
      window.removeEventListener(NavigationEvents.ENTER_USER_PROFILE, handler)
    }
  }, [])
}
